import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BigInfo from './components/BigInfo/BigInfo';
import CasePreview from './components/CasePreview/CasePreview';
import FeatureBlock from './components/FeatureBlock/FeatureBlock';
import FlexContainer from '@components/FlexContainer/FlexContainer';
import IconBar from './components/IconBar/IconBar';
import SecondIconBar from './components/SecondIconBar/SecondIconBar';
import Separator from './components/Separator/Separator';
import TextWall from './components/TextWall/TextWall';

import { getCasePreview } from '@actions/casePreview';

import { caseList } from '@selectors/casePreview';
import { isGreaterThanMobile } from '@selectors/browser';

import './Landing.scss';

class Landing extends React.Component {
  componentDidMount() {
    this.props.fetchCasePreview();
  }

  render() {
    const {
      caseList,
      isMobile,
    } = this.props;

    return (
      <div className="landing">
        <div className="landing__feature-block">
          <FlexContainer>
            <FeatureBlock isMobile={isMobile} />
          </FlexContainer>
        </div>
        <div className="landing__case-preview">
          <FlexContainer>
            <CasePreview data={caseList} />
          </FlexContainer>
        </div>
        <div className="landing__icon-bar">
          <IconBar />
        </div>
        {!isMobile && (
          <div className="landing__separator">
            <Separator />
          </div>
        )}
        <div className="landing__text-wall">
          <FlexContainer>
            <TextWall />
          </FlexContainer>
        </div>
        <div className="landing__big-info">
          <FlexContainer>
            <BigInfo />
          </FlexContainer>
        </div>
        <div className="landing__second-icon-bar">
          <SecondIconBar />
        </div>
        {!isMobile && (
          <div className="landing__separator">
            <Separator isBlack />
          </div>
        )}
      </div>
    );
  }
}

Landing.propTypes = {
  caseList: PropTypes.array.isRequired,
  fetchCasePreview: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  caseList: caseList(state),
  isMobile: !isGreaterThanMobile(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCasePreview: getCasePreview,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Landing);



// WEBPACK FOOTER //
// ./src/routes/Landing/Landing.js